import React from "react"
import { useParams } from "react-router-dom"
import { EDIT } from "../../include/constant"
import ShopForm from "../common/ShopForm"
import SuperAdminHeader from "./Header"

const SuperAdminEditShop = () => {
    const { id } = useParams()
    return <div className="fixed-top-bar">
        <SuperAdminHeader />
        <ShopForm
            id={id}
            title="Edit Shop"
            type={EDIT}
        />
    </div>
}

export default SuperAdminEditShop